import { render, staticRenderFns } from "./adverPage.vue?vue&type=template&id=25a7c7d8&"
import script from "./adverPage.vue?vue&type=script&lang=js&"
export * from "./adverPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports